import React, { ReactNode } from 'react';

type ConnectedPagesGrandparentEdge = {
  diameter: number;
  width: number;
  children: ReactNode;
};

export default function ConnectedPagesGrandparentEdge({ diameter, width, children }: ConnectedPagesGrandparentEdge) {
  return (
    <svg
      className="connected-pages-graph__svg"
      // Accessibility
      aria-hidden="true"
      focusable="false"
    >
      <line
        key="line-parent"
        className="connected-pages-graph__svg-line-parent"
        x2={diameter / 2}
        y2={diameter / 2}
        x1={width}
        y1={width}
      />
      {children}
    </svg>
  );
}
